import { useMe } from '@/api/me';
import { Container } from '@vnetwork/ui/layout';
import { QuoteBanner } from './widgets/QuoteBanner';
import { MyTicketsWidget } from './widgets/MyTicketsWidget';
import { SlaOverviewWidget } from './widgets/SlaOverviewWidget';
import { MyWorkdaysWidget } from './widgets/MyWorkdaysWidget';
import { OncallScheduleWidget } from './widgets/OncallScheduleWidget';
import { WorkScheduleWidget } from './widgets/WorkScheduleWidget';
import { DocumentsWidget } from './widgets/DocumentsWidget';
import { RevenueStatsWidget } from './widgets/RevenueStatsWidget';
import { BusinessTripsWidget } from './widgets/BusinessTripsWidget';

const ROW: React.CSSProperties = { display: 'grid', gap: 'var(--vn-space-4)' };

/**
 * Department dashboard — the workspace home, fullwidth, modelled on the legacy
 * DataCentral TechDashboard. Scoped to the signed-in employee's department
 * (from /auth/me). All widgets render live data via the UMA-authorized client.
 */
export default function DashboardPage() {
  const { data: me } = useMe();
  const department = me?.employee?.department_name;

  return (
    <Container size="full">
      <div style={{ display: 'grid', gap: 'var(--vn-space-4)' }}>
        <QuoteBanner />

        {/* SLA overview (wide, left) + my tickets (right) */}
        <div style={{ ...ROW, gridTemplateColumns: 'minmax(0, 1.7fr) minmax(320px, 1fr)' }}>
          <SlaOverviewWidget />
          <MyTicketsWidget />
        </div>

        {/* Team: on-call roster (wide) + work schedule */}
        <div style={{ ...ROW, gridTemplateColumns: 'minmax(0, 1.7fr) minmax(300px, 1fr)' }}>
          <OncallScheduleWidget department={department} />
          <WorkScheduleWidget />
        </div>

        {/* Documents & notices (wide) + revenue */}
        <div style={{ ...ROW, gridTemplateColumns: 'minmax(0, 1.7fr) minmax(320px, 1fr)' }}>
          <DocumentsWidget />
          <RevenueStatsWidget />
        </div>

        {/* My attendance (Ngày công của tôi) + business trips */}
        <div style={{ ...ROW, gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))' }}>
          <MyWorkdaysWidget />
          <BusinessTripsWidget />
        </div>
      </div>
    </Container>
  );
}
